module.exports = __webpack_public_path__ + "img/SC.39f21f12.png";